module.exports = __webpack_public_path__ + "img/soundSubtract.9472e351.svg";